import { createContext, useContext } from 'react';
const noop = () => { };
export const ShellContext = createContext({ brand: { mark: 'OS', name: 'OS' }, menuOpen: false, setMenuOpen: noop });
/** Brand + mobile-menu state provided by `AppShell`. Safe to call outside a shell (defaults). */
export function useShell() {
    return useContext(ShellContext);
}
//# sourceMappingURL=ShellContext.js.map